module.exports = __webpack_public_path__ + "static/media/default_thumbnail_84_64.5361872d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_84_64.jpg
// module id = 310
// module chunks = 2